import { Component, input, model } from '@angular/core';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { SortOption } from '../../../core/models/ui/sort-option.model';
import { GlobalConstants } from '../../../core/constants/constants';

@Component({
  selector: 'ms-sort-dropdown',
  imports: [FontAwesomeModule],
  templateUrl: './sort-dropdown.html',
  styleUrl: './sort-dropdown.scss'
})
export class SortDropdownComponent {
  public sortOptions = input<SortOption[]>();
  public selectedSortOption = model<string>('');

  public onSortChange(value: string): void {
    this.selectedSortOption.set(value); 
  }

  public convertSortOptionArrayToString(value: string, isAsc: boolean): string {
    return isAsc ? value + `${GlobalConstants.ASCENDING_ABBREVIATION()}` : value + `${GlobalConstants.DESCENDING_ABBREVIATION()}`;
  }
}
